import React, { useEffect, useState } from 'react'
import './index.less'
import { OpenScreen } from './OpenScreen'
import { Footer } from '@/components/Footer'
import { selectBackground, upArrow } from '@/assets/images'
import { Theme } from './Theme'
import { Author } from './Author'
import { Dynasty } from './Dynasty'
import { Criteria } from './Criteria'
import { Technique } from './Technique'
import { Museum } from './Museum'

export function IndexPage() {
  // 当前展示的模块
  const [showType, setShowType] = useState<string>('theme')
  // 初始化hash值，和showType的初始值同步
  useEffect(() => {
    window.location.hash = showType
  }, [])
  //切换showType的回调
  const handleChangeShowType = function (type: string) {
    window.location.hash = categoriesList[type]
  }
  // 吸顶图标显隐控制
  const [topDisplay, setTopDisplay] = useState(false)
  const categoriesList = {
    作者: 'author',
    朝代: 'dynasty',
    // 画派: "faction",
    主题: 'theme',
    技法: 'technique',
    画幅: 'criteria',
    藏馆: 'museum'
  }
  useEffect(() => {
    // 监听滚动高度，控制吸顶图标显隐
    const handleScroll = function () {
      // 上面隐藏的高度
      const scrollHeight =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      if (scrollHeight > 1500) {
        setTopDisplay(true)
      } else {
        setTopDisplay(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  // 监听hash变化，同步最新hash值到showType
  window.onhashchange = function (e) {
    setShowType(e.newURL.slice(e.newURL.indexOf('#') + 1))
  }
  return (
    <>
      <div className='index-page-container'>
        <div
          className='back-to-top'
          onClick={() => (document.body.scrollTop = 0)}
          style={{ visibility: topDisplay ? 'visible' : 'hidden' }}
        >
          <img src={upArrow} alt='uparrow'></img>
        </div>
        <OpenScreen />
        <div className='select-area'>
          {Object.keys(categoriesList).map((type, _i) => {
            return (
              <div
                className='select-item'
                style={{ color: showType === categoriesList[type] ? 'white' : 'black' }}
                onClick={() => handleChangeShowType(type)}
                key={type}
              >
                <img
                  style={{ display: showType === categoriesList[type] ? 'block' : 'none' }}
                  src={selectBackground}
                  alt=''
                />
                &nbsp;{type}
              </div>
            )
          })}
        </div>
        {(() => {
          switch (showType) {
            case 'theme':
              return <Theme />
            // case "faction":
            //   return <Faction />
            case 'author':
              return <Author />
            case 'dynasty':
              return <Dynasty />
            case 'criteria':
              return <Criteria />
            case 'technique':
              return <Technique />
            case 'museum':
              return <Museum />
            default:
              return null
          }
        })()}
      </div>
      <Footer />
    </>
  )
}
